/**
 * Feature-scoped debug flag table for the chat module. Kept here
 * rather than registered in the central `enabledDebuggers` registry
 * because these are noisy by nature and only relevant when working on
 * chat itself.
 *
 * Pair with `makeDebug` from `@ps/functions/utils/debug`, passing
 * `isChatDebugEnabled(name)` as the explicit `enabled` arg:
 *
 *   const debug = makeDebug('chat:gateway', isChatDebugEnabled('gateway'));
 */
const enabled: Record<string, boolean> = {
  gateway: false,
  gatewayIO: false,
  session: false,
  pendingMessages: false,
};

export function isChatDebugEnabled(name: keyof typeof enabled): boolean {
  return process.env.NODE_ENV !== 'production' && enabled[name] === true;
}
